import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <a
            href="https://github.com/gabricrl"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>

          <span>•</span>

          <a
            href="https://www.linkedin.com/in/gabriel-samson-9464a63a5/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>

          <span>•</span>

          <a href="mailto:samsongabriel.it@gmail.com">
            Email
          </a>

          <span>•</span>

          <a href="https://drive.google.com/drive/folders/1-wCRiLm_zAQ6ZLtso1ujvYrC-aKwyBml?usp=sharing">
            GDrive
          </a>
        </div>

        <p className="footer-copy">
          © {new Date().getFullYear()} Gabriel Samson. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
